import React from "react";
import {titleCodes, textCodes} from  "../../template_codes/willow/contact_page_codes";

function Contact() {
    return(
        <div className="py-20 lg:text-center xl:text-center pl-10">
                <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">{titleCodes.contact.title}</h1>
                <ul className="list-none">
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{titleCodes.address.title}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.address1.text}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.address2.text}</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{titleCodes.email.title}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.emailText.text}</p>
                    </li>
                </ul>
            </div>
    );
}

export default Contact;